export default __webpack_public_path__ + "static/media/PrivacyPolicy.3c20446f.pdf";